module.exports = __webpack_public_path__ + "static/media/vi-data-roaming-other_2.f8c8739e.png";